<template>
  <div>
    <div
      v-for="(field, index) in fields"
      :key="field.slug"
      class="px-3 pb-3"
      :class="{ 'border-bottom': index !== fields.length - 1 }"
    >
      <odd-label>{{ field.label }}</odd-label>
      <textarea
        v-if="field.type === 'textarea'"
        class="mb-0 form-control"
        :value="!!value[field.slug] ? value[field.slug] : ''"
        @input="val => handleTextArea(val, field.slug)"
      />
      <d-checkbox
        v-else-if="field.type === 'checkbox'"
        class="mb-0"
        :checked="!!value[field.slug]"
        @change="() => handleCheckBox(!!!value[field.slug], field.slug)"
      />
      <d-input
        v-else
        :type="field.type"
        class="mb-0"
        :value="!!value[field.slug] ? value[field.slug] : ''"
        @input="val => handleInput(val, field.slug)"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentValues: {}
    };
  },
  props: {
    fields: {
      type: Array
    },
    value: {
      type: Object
    }
  },
  methods: {
    handleTextArea(e, slug) {
      let updated = this.value;
      updated[slug] = e.target.value;
      this.$emit("input", updated);
    },
    handleInput(val, slug) {
      let updated = JSON.parse(JSON.stringify(this.value));
      updated[slug] = val;
      this.$emit("input", updated);
    },
    handleCheckBox(val, slug) {
      let updated = JSON.parse(JSON.stringify(this.value));
      updated[slug] = val;
      this.$emit("input", updated);
    }
  }
};
</script>

<style></style>
